// sagas
// import SomeSaga from 'containers/Some/sagas';

// modules
import { createStore, applyMiddleware } from 'redux';
import reducers from 'reducers';
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'react-router-redux'
import { createLogger } from 'redux-logger'
import thunk from 'redux-thunk'
// import createSagaMiddleware from 'redux-saga';
import { fromJS } from 'immutable';

const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL ? process.env.PUBLIC_URL : ''
});

// Apply the middleware to the store
const router = routerMiddleware(history);

// const saga = createSagaMiddleware();

const middleware = [ thunk, router/*, saga*/ ];

if (process.env.NODE_ENV !== 'production') {
  middleware.push(createLogger({
    collapsed: true,
    stateTransformer: state => state.toJS()
  }))
}

const store = createStore(reducers, fromJS({}), applyMiddleware(...middleware));

// Extensions
// store.runSaga = saga.run;
store.history = history;

// запускаем саги
// [
//   ...SomeSaga,
// ].map(saga.run);

export default store;



// WEBPACK FOOTER //
// ./src/store.js